import type { PlanType } from "@prisma/client";

/** Días de calendario locales hasta la fecha (0 = vence hoy). */
export function calendarDaysUntil(date: Date | string): number {
  const end = typeof date === "string" ? new Date(date) : date;
  const endLocal = new Date(end.getFullYear(), end.getMonth(), end.getDate());
  const now = new Date();
  const startLocal = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  return Math.round((endLocal.getTime() - startLocal.getTime()) / 86400000);
}

/** Días de prueba restantes; null si no aplica (FREE o sin vencimiento). */
export function computeTrialDaysLeft(
  plan: PlanType | string,
  planExpiresAt: Date | string | null | undefined,
): number | null {
  if (!planExpiresAt || plan === "FREE") return null;
  return calendarDaysUntil(planExpiresAt);
}

export function formatTrialDaysLeftLabel(days: number | null): string {
  if (days === null) return "—";
  if (days <= 0) return "Prueba vencida";
  if (days === 1) return "1 día restante";
  return `${days} días restantes`;
}

export type RealStatus = "paying" | "on_trial" | "trial_expired" | "inactive" | "free";

/** Estado real de facturación de una cuenta; mismo criterio que usan Planes y MRR. */
export function computeRealStatus(
  plan: PlanType | string,
  planExpiresAt: Date | string | null | undefined,
  isActive: boolean,
): RealStatus {
  if (!isActive) return "inactive";
  if (plan === "FREE") return "free";
  const trialDaysLeft = computeTrialDaysLeft(plan, planExpiresAt);
  if (trialDaysLeft !== null) return trialDaysLeft > 0 ? "on_trial" : "trial_expired";
  return "paying";
}
